<section class="admin-shell">
  <header class="topbar">
    <div class="topbar__brand">
      <button class="icon-button" type="button" (click)="goBack()" matTooltip="Voltar">
        <mat-icon>arrow_back</mat-icon>
      </button>

      <div class="topbar__title">
        <span>Lofi Radio</span>
        <h1>Admin</h1>
      </div>
    </div>

    <button class="button button--ghost" type="button" (click)="logout()">
      <mat-icon>logout</mat-icon>
      <span>Sair</span>
    </button>
  </header>

  <main class="admin-content">
    <section class="metrics-grid" aria-label="Resumo">
      <article class="metric-card">
        <div class="metric-card__icon metric-card__icon--green">
          <mat-icon>person</mat-icon>
        </div>
        <div>
          <span>Ouvintes</span>
          <strong>{{ connectedUsersCount }}</strong>
        </div>
      </article>

      <article class="metric-card">
        <div class="metric-card__icon metric-card__icon--blue">
          <mat-icon>queue_music</mat-icon>
        </div>
        <div>
          <span>Radios</span>
          <strong>{{ chipArray.length }}</strong>
        </div>
      </article>

      <article class="metric-card">
        <div class="metric-card__icon metric-card__icon--violet">
          <mat-icon>subscriptions</mat-icon>
        </div>
        <div>
          <span>Youtubers</span>
          <strong>{{ youtuberArray.length }}</strong>
        </div>
      </article>

      <article class="metric-card" [class.metric-card--danger]="isQuotaExhausted()">
        <div class="metric-card__icon metric-card__icon--amber">
          <mat-icon>{{ isQuotaExhausted() ? 'warning' : 'data_usage' }}</mat-icon>
        </div>
        <div>
          <span>Quota</span>
          <strong>{{ quotaLabel }}</strong>
        </div>
      </article>
    </section>

    <app-profile-visits-chart></app-profile-visits-chart>

    <section class="workspace">
      <aside class="tools-column">
        <section class="tool-panel">
          <div class="panel-heading">
            <div>
              <span>Radio</span>
              <h2>Adicionar video</h2>
            </div>
            <mat-icon>add_circle</mat-icon>
          </div>

          <form class="control-form" (ngSubmit)="chipCreateForm()" [formGroup]="chipCreate">
            <label for="chipname">URL ou ID do video</label>
            <div class="field-row">
              <input type="text" id="chipname" placeholder="youtube.com/watch?v=..." formControlName="chipname" required>
              <button class="button button--primary" type="submit" [disabled]="isAddingChip || isSavingChipOrder">
                <mat-icon>{{ isAddingChip ? 'hourglass_empty' : 'add' }}</mat-icon>
                <span>Adicionar</span>
              </button>
            </div>
          </form>
        </section>

        <section class="tool-panel">
          <div class="panel-heading">
            <div>
              <span>Youtubers</span>
              <h2>Canais monitorados</h2>
            </div>
            <mat-icon>live_tv</mat-icon>
          </div>

          <form class="control-form" (ngSubmit)="youtuberCreateForm()" [formGroup]="youtuberCreate">
            <label for="youtuber">Canal</label>
            <div class="field-row">
              <input type="text" id="youtuber" placeholder="@canal ou link" formControlName="youtuber" required>
              <button class="button button--primary" type="submit" [disabled]="isAddingYoutuber || isSavingYoutuberOrder">
                <mat-icon>{{ isAddingYoutuber ? 'hourglass_empty' : 'person_add' }}</mat-icon>
                <span>Salvar</span>
              </button>
            </div>
          </form>

          <button
            class="button button--success button--full"
            type="button"
            (click)="syncCurrentLives()"
            [disabled]="isSyncingLives || isSavingChipOrder || isSavingYoutuberOrder || youtuberArray.length === 0"
          >
            <mat-icon>{{ isSyncingLives ? 'hourglass_empty' : 'radio' }}</mat-icon>
            <span>{{ isSyncingLives ? 'Buscando' : 'Adicionar lives' }}</span>
          </button>

          <div class="channel-toolbar" *ngIf="youtuberArray.length">
            <span>{{ youtuberArray.length }} {{ youtuberArray.length === 1 ? 'canal' : 'canais' }}</span>
            <button
              class="button button--ghost button--compact"
              type="button"
              (click)="sortYoutubersAlphabetically()"
              [disabled]="isSavingYoutuberOrder"
              matTooltip="Organizar youtubers por nome"
            >
              <mat-icon>{{ isSavingYoutuberOrder ? 'hourglass_empty' : 'sort_by_alpha' }}</mat-icon>
              <span>{{ isSavingYoutuberOrder ? 'Salvando' : 'Ordenar A-Z' }}</span>
            </button>
          </div>

          <div
            class="channel-list"
            *ngIf="youtuberArray.length; else emptyYoutubers"
            cdkDropList
            [cdkDropListData]="youtuberArray"
            (cdkDropListDropped)="onYoutuberDrop($event)"
          >
            <article
              class="channel-row"
              *ngFor="let youtuber of youtuberArray; let index = index; trackBy: trackByYoutuberId"
              cdkDrag
              [cdkDragData]="youtuber"
              [cdkDragDisabled]="isSavingYoutuberOrder"
            >
              <button
                class="drag-handle"
                type="button"
                cdkDragHandle
                [disabled]="isSavingYoutuberOrder"
                (keydown)="onYoutuberHandleKeydown($event, index)"
                matTooltip="Mover"
                [attr.aria-label]="'Mover ' + youtuber.title + '. Use as setas, Home ou End.'"
              >
                <mat-icon>drag_indicator</mat-icon>
              </button>

              <img *ngIf="youtuber.thumbnailUrl" [src]="youtuber.thumbnailUrl || ''" [alt]="youtuber.title">
              <span class="avatar-fallback" *ngIf="!youtuber.thumbnailUrl">
                <mat-icon>account_circle</mat-icon>
              </span>

              <div class="channel-row__content">
                <strong>{{ youtuber.title }}</strong>
                <span>{{ youtuber.handle || youtuber.channelId }}</span>
              </div>

              <button class="row-action row-action--danger" type="button" (click)="deleteYoutuber(youtuber.id)" [disabled]="isSavingYoutuberOrder" matTooltip="Remover" [attr.aria-label]="'Remover ' + youtuber.title">
                <mat-icon>delete</mat-icon>
              </button>
            </article>
          </div>

          <ng-template #emptyYoutubers>
            <div class="empty-state empty-state--compact">
              <mat-icon>subscriptions</mat-icon>
              <span>Nenhum canal cadastrado</span>
            </div>
          </ng-template>
        </section>
      </aside>

      <section class="list-panel">
        <div class="list-panel__header">
          <div>
            <span>Playlist</span>
            <h2>Radios cadastradas</h2>
          </div>
          <div class="list-panel__actions">
            <button
              class="button button--ghost button--compact"
              type="button"
              (click)="sortChipsAlphabetically()"
              [disabled]="isChipSortDisabled"
              matTooltip="Organizar radios por titulo"
            >
              <mat-icon>{{ isSavingChipOrder ? 'hourglass_empty' : 'sort_by_alpha' }}</mat-icon>
              <span>{{ isSavingChipOrder ? 'Salvando' : 'Ordenar A-Z' }}</span>
            </button>
            <button
              class="button button--danger button--compact"
              type="button"
              (click)="cleanNonWorkingLives()"
              [disabled]="isCleaningLives || isSavingChipOrder || chipArray.length === 0"
            >
              <mat-icon>{{ isCleaningLives ? 'hourglass_empty' : 'delete_sweep' }}</mat-icon>
              <span>{{ isCleaningLives ? 'Verificando' : 'Limpar inativas' }}</span>
            </button>
            <span class="count-pill">{{ chipArray.length }}</span>
          </div>
        </div>

        <div
          class="radio-list"
          *ngIf="chipArray.length; else emptyRadios"
          cdkDropList
          [cdkDropListData]="chipArray"
          (cdkDropListDropped)="onDrop($event)"
        >
          <article class="radio-row" *ngFor="let chip of chipArray; let index = index; trackBy: trackByChipId" cdkDrag [cdkDragData]="chip" [cdkDragDisabled]="isSavingChipOrder">
            <button
              class="drag-handle"
              type="button"
              cdkDragHandle
              [disabled]="isSavingChipOrder"
              (keydown)="onChipHandleKeydown($event, index)"
              matTooltip="Mover"
              [attr.aria-label]="'Mover ' + (chip.title || chip.chipname) + '. Use as setas, Home ou End.'"
            >
              <mat-icon>drag_indicator</mat-icon>
            </button>

            <span class="order-badge">{{ chip.order }}</span>

            <div class="radio-row__content">
              <strong>{{ chip.title || 'Carregando...' }}</strong>
              <span>{{ chip.creator || 'YouTube' }}</span>
              <code>{{ chip.chipname }}</code>
            </div>

            <button class="row-action row-action--danger" type="button" (click)="deleteChip(chip.id)" [disabled]="isSavingChipOrder" matTooltip="Remover" [attr.aria-label]="'Remover ' + (chip.title || chip.chipname)">
              <mat-icon>delete</mat-icon>
            </button>
          </article>
        </div>

        <ng-template #emptyRadios>
          <div class="empty-state">
            <mat-icon>queue_music</mat-icon>
            <span>Nenhuma radio cadastrada</span>
          </div>
        </ng-template>
      </section>
    </section>

    <section class="tool-panel theme-panel theme-panel--bottom" id="theme-editor">
      <div class="panel-heading theme-panel__header">
        <span class="theme-heading-icon">
          <mat-icon aria-hidden="true">palette</mat-icon>
        </span>
        <div class="theme-panel__heading-copy">
          <span>Aparencia</span>
          <h2>{{ isEditingTheme ? 'Editar tema de cores' : 'Novo tema de cores' }}</h2>
          <p class="panel-description">
            Monte a paleta, confira o resultado no preview e salve. Os temas podem ser editados e reordenados abaixo.
          </p>
        </div>
        <span class="editing-pill" *ngIf="isEditingTheme">Editando</span>
      </div>

      <form class="control-form theme-form" (ngSubmit)="themeCreateForm()" [formGroup]="themeCreate">
        <div class="theme-editor-grid">
          <div class="theme-fields">
            <label for="theme-name">Nome do tema</label>
            <input
              type="text"
              id="theme-name"
              placeholder="Ex.: Noite neon"
              formControlName="name"
              maxlength="40"
              autocomplete="off"
              required
            >
            <small class="field-error" *ngIf="themeCreate.get('name')?.touched && themeCreate.get('name')?.invalid">
              Informe um nome com ate 40 caracteres.
            </small>

            <div class="color-field-grid">
              <div
                class="color-field"
                *ngFor="let field of themeColorFields"
              >
                <label [attr.for]="'theme-' + field.key">{{ field.label }}</label>
                <span
                  class="color-control"
                  [class.color-control--invalid]="themeCreate.get(field.key)?.touched && themeCreate.get(field.key)?.invalid"
                >
                  <input
                    type="color"
                    [id]="'theme-' + field.key + '-picker'"
                    [value]="getThemeColorPreview(field.key)"
                    (input)="updateThemeColor(field.key, $event)"
                    [attr.aria-label]="'Selecionar cor ' + field.label"
                    [disabled]="isSavingTheme"
                  >
                  <input
                    class="color-hex-input"
                    type="text"
                    [id]="'theme-' + field.key"
                    [formControlName]="field.key"
                    (blur)="normalizeThemeColor(field.key)"
                    maxlength="7"
                    spellcheck="false"
                    autocomplete="off"
                    [attr.aria-label]="'Codigo hexadecimal da cor ' + field.label"
                  >
                </span>
                <small class="field-error" *ngIf="themeCreate.get(field.key)?.touched && themeCreate.get(field.key)?.invalid">
                  Use #RRGGBB.
                </small>
              </div>
            </div>

            <div class="theme-form__tools">
              <button class="button button--ghost button--compact" type="button" (click)="resetThemeColors()" [disabled]="isSavingTheme">
                <mat-icon>restart_alt</mat-icon>
                <span>Restaurar cores</span>
              </button>
            </div>

            <div class="theme-form__actions">
              <button
                class="button button--ghost"
                *ngIf="isEditingTheme"
                type="button"
                (click)="cancelThemeEdit()"
                [disabled]="isSavingTheme"
              >
                <span>Cancelar</span>
              </button>
              <button class="button button--primary" type="submit" [disabled]="isSavingTheme || isSavingThemeOrder || themeCreate.invalid">
                <mat-icon>{{ isSavingTheme ? 'hourglass_empty' : (isEditingTheme ? 'save' : 'add') }}</mat-icon>
                <span>{{ isSavingTheme ? 'Salvando' : (isEditingTheme ? 'Salvar alteracoes' : 'Adicionar tema') }}</span>
              </button>
            </div>
            <p class="form-error" *ngIf="themeSaveError" role="alert">{{ themeSaveError }}</p>
          </div>

          <div class="theme-preview-column">
            <span class="theme-preview-label">Mini preview</span>
            <div class="theme-preview" [ngStyle]="themePreviewStyles" aria-label="Mini preview do tema">
              <div class="theme-preview__topbar">
                <span class="theme-preview__brand">LOFI</span>
                <span class="theme-preview__dot"></span>
              </div>
              <div class="theme-preview__content">
                <div class="theme-preview__cover">
                  <mat-icon>headphones</mat-icon>
                </div>
                <div class="theme-preview__copy">
                  <strong>{{ themeCreate.get('name')?.value || 'Seu novo tema' }}</strong>
                  <span>Chill beats radio</span>
                  <button type="button" tabindex="-1">
                    <mat-icon>play_arrow</mat-icon>
                    Ouvir
                  </button>
                </div>
              </div>
              <div class="theme-preview__palette" aria-hidden="true">
                <i></i><i></i><i></i><i></i>
              </div>
            </div>
          </div>
        </div>
      </form>

      <div class="saved-themes">
        <div class="saved-themes__header">
          <div>
            <span class="saved-themes__eyebrow">Biblioteca</span>
            <strong>Temas cadastrados</strong>
          </div>
          <div class="saved-themes__actions">
            <div class="theme-sort-control" role="group" aria-label="Ordenar temas">
              <span>Exibir por</span>
              <button
                type="button"
                [class.is-active]="themeSortMode === 'order'"
                [attr.aria-pressed]="themeSortMode === 'order'"
                (click)="setThemeSortMode('order')"
                [disabled]="isSavingThemeOrder"
                matTooltip="Ordem manual salva"
              >
                <mat-icon>format_list_numbered</mat-icon>
                Ordem
              </button>
              <button
                type="button"
                [class.is-active]="themeSortMode === 'alphabetical'"
                [attr.aria-pressed]="themeSortMode === 'alphabetical'"
                (click)="setThemeSortMode('alphabetical')"
                [disabled]="isSavingThemeOrder"
                matTooltip="Ordem alfabetica"
              >
                <mat-icon>sort_by_alpha</mat-icon>
                A-Z
              </button>
            </div>
            <span class="count-pill">{{ themeArray.length }}</span>
          </div>
        </div>

        <div
          class="theme-list"
          *ngIf="themeArray.length; else emptyThemes"
          cdkDropList
          [cdkDropListData]="themeArray"
          (cdkDropListDropped)="onThemeDrop($event)"
          [attr.aria-label]="themeSortMode === 'order' ? 'Temas cadastrados. Arraste para reordenar.' : 'Temas cadastrados em ordem alfabetica.'"
        >
          <article
            class="saved-theme"
            *ngFor="let theme of themeArray; let index = index; trackBy: trackByThemeId"
            [class.saved-theme--editing]="editingThemeId === theme.id"
            cdkDrag
            [cdkDragData]="theme"
            [cdkDragDisabled]="isSavingThemeOrder || themeSortMode !== 'order'"
          >
            <button
              class="drag-handle"
              type="button"
              cdkDragHandle
              [disabled]="isSavingThemeOrder || themeSortMode !== 'order'"
              (keydown)="onThemeHandleKeydown($event, index)"
              [matTooltip]="themeSortMode === 'order' ? 'Mover' : 'Selecione Ordem para reordenar'"
              [attr.aria-label]="themeSortMode === 'order' ? 'Mover tema ' + theme.name + '. Use as setas, Home ou End.' : 'Tema ' + theme.name + '. Selecione Ordem para reordenar.'"
            >
              <mat-icon>drag_indicator</mat-icon>
            </button>

            <span class="order-badge">{{ theme.order || index + 1 }}</span>

            <div class="saved-theme__content">
              <strong>{{ theme.name }}</strong>
              <div class="saved-theme__palette" [attr.aria-label]="'Paleta do tema ' + theme.name">
                <i *ngFor="let field of themeColorFields" [style.background-color]="theme.colors[field.key]" [matTooltip]="field.label + ': ' + theme.colors[field.key]"></i>
              </div>
            </div>

            <div class="saved-theme__actions">
              <button class="row-action" type="button" (click)="duplicateTheme(theme)" [disabled]="isSavingThemeOrder" [attr.aria-label]="'Duplicar tema ' + theme.name" matTooltip="Duplicar">
                <mat-icon>content_copy</mat-icon>
              </button>
              <button class="row-action" type="button" (click)="editTheme(theme)" [disabled]="isSavingThemeOrder" [attr.aria-label]="'Editar tema ' + theme.name" matTooltip="Editar">
                <mat-icon>edit</mat-icon>
              </button>
              <button class="row-action row-action--danger" type="button" (click)="deleteTheme(theme)" [disabled]="isSavingThemeOrder" [attr.aria-label]="'Excluir tema ' + theme.name" matTooltip="Remover">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </article>
        </div>

        <ng-template #emptyThemes>
          <div class="empty-state empty-state--compact">
            <mat-icon>palette</mat-icon>
            <span>Nenhum tema cadastrado</span>
            <small>Crie a primeira paleta usando o editor acima.</small>
          </div>
        </ng-template>
      </div>
    </section>
  </main>
</section>
